import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SelectionGenericService } from '../../services/selection-generic.service';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import { AddTimeComponent } from 'app/modules/task/components/add-time/add-time.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatDialog } from '@angular/material/dialog';
import Utils from 'app/Utils';

@Component({
    selector: 'app-selection-list',
    templateUrl: './selection-list.component.html',
    styleUrls: ['./selection-list.component.scss'],
    standalone: false
})
export class SelectionListComponent implements OnInit {

  permissionList: Array<string>;
  constructor(public selectionService: SelectionGenericService,
              public taskService: TaskSaveService, 
              public dialog: MatDialog,
              public sharedService: SharedService) { }

  ngOnInit() {
    this.permissionList = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
  }

  

}
